var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"guide",on:{"click":function($event){$event.stopPropagation();return _vm.close.apply(null, arguments)}}},[_c('div',{staticClass:"popup"},[_c('img',{staticClass:"img",attrs:{"src":_vm.guideUrl,"mode":""}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }